import {Component} from '@angular/core';
import {PageInfo} from "../../../shared/model/response/page-info.model";
import {AuthtokenResponse} from "../../../shared/model/response/auth/authtoken-response.model";
import {EventFilterModel} from "../../../shared/model/request/event-filter.model";
import {AuthenticationService} from "../../../service/authentication-service";
import {PaginatorState} from "primeng/paginator";
import {ContactRequestService} from "../../../service/api/contact-request.service";
import {ContactRequestResponseModel} from "../../../shared/model/response/event/contactRequestResponse.model";
import {ApiResponse} from "../../../shared/model/response/ApiResponse";
import {ModalService} from "../../../service/modal.service";
import {MessagesEnum} from "../../../shared/enums/messages.enum";
import {MessageToastService} from "../../../service/message-toast.service";
import {ContactRequestFilterModel} from "../../../shared/model/request/contact-request-filter.model";

@Component({
    selector: 'app-event-contact',
    templateUrl: './event-contact.component.html',
    standalone: false
})
export class EventContactComponent {

  contactRequests: ContactRequestResponseModel[];
  pagination: PageInfo

  user: AuthtokenResponse

  eventFilters: EventFilterModel
  tableHasdata: boolean = true

  constructor(
    private contactRequestService: ContactRequestService,
    private authenticationService: AuthenticationService,
    private modalService: ModalService,
    private messageService: MessageToastService
  ) {
  }

  ngOnInit() {
    this.user = this.authenticationService._user.getValue()
    this.apiListContactRequestService({})
  }

  onFilterSubmit($event: EventFilterModel) {
    this.eventFilters = $event
    this.apiListContactRequestService(this.eventFilters)
  }

  apiListContactRequestService(filters: ContactRequestFilterModel, page?: number) {
    this.contactRequestService.getAll(page, filters)
      .subscribe({
          next: (value) => {
            this.contactRequests = value?.data
            this.pagination = value.pageInfo
            this.tableHasdata = this.contactRequests.length > 0
          },
          error: () => {
            if (page == 0) {
              this.tableHasdata = false;
              this.contactRequests = null;
            }
          }
        }
      )
  }

  answerContactRequestAlert(contactRequestId: number, answer: boolean) {
    this.modalService.simpleConfirmation({
      message: answer ? MessagesEnum.acceptContactRequest : MessagesEnum.rejectContactRequest
    }).then(confirmed => {
      if (confirmed) {
        this.apiAnswerContactRequest(contactRequestId, answer)
      }
    })
  }

  apiAnswerContactRequest(contactRequestId: number, answer: boolean) {
    const contactRequestIndex = this.contactRequests.findIndex(el => el.id == contactRequestId)

    this.contactRequestService.answerContactRequest(contactRequestId, answer)
      .subscribe({
        next: (response: ApiResponse<ContactRequestResponseModel>) => {
          this.messageService.success(response.message)
          this.contactRequests.splice(contactRequestIndex, 1)
        },
        error: (response: ApiResponse<ContactRequestResponseModel>) => this.messageService.error(response.message)
      })
  }

  onPageChange($event: PaginatorState) {
    this.apiListContactRequestService(this.eventFilters, $event.page)
  }

}
